export default class KpiSetting {
  public id!: string;
  public template_id!: string;
  public factory_id!: string;

  public task_update_day?: number;
  public task_starts_day?: number;
  public task_ends_day?: number;
}
